import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const ProperStandard = () => {
  const { language } = useLanguage();
  
  const [formData, setFormData] = useState({
    // Applicant Information
    applicantName: '',
    mobileNumber: '',
    
    // Certificate Details
    personNameMarathi: '',
    personNameEnglish: '',
    familyHeadNameMarathi: '',
    povertyLineNumber: '',
    relationWithFamilyHead: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Handle form submission logic here
  };

  const handleReset = () => {
    setFormData({
      applicantName: '',
      mobileNumber: '',
      personNameMarathi: '',
      personNameEnglish: '',
      familyHeadNameMarathi: '',
      povertyLineNumber: '',
      relationWithFamilyHead: '',
    });
  };

  const formSectionStyle = {
    background: 'linear-gradient(135deg, #f1f8ff 0%, #e3f2fd 100%)',
    borderRadius: '10px',
    padding: '20px',
    marginBottom: '20px',
    border: '1px solid #bbdefb',
    boxShadow: '0 2px 8px rgba(33, 150, 243, 0.1)',
  };

  const inputStyle = {
    background: '#ffffff',
    border: '1px solid #90caf9',
    borderRadius: '6px',
    padding: '10px 15px',
    fontSize: '14px',
    transition: 'all 0.3s ease',
    width: '100%',
  };

  const labelStyle = {
    color: '#1565c0',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '8px',
    display: 'block',
  };

  const sectionTitleStyle = {
    color: '#0d47a1',
    fontSize: '18px',
    fontWeight: '700',
    marginBottom: '15px',
    paddingBottom: '10px',
    borderBottom: '2px solid #2196f3',
    textAlign: 'center',
  };

  const requiredStar = {
    color: '#f44336',
    marginLeft: '3px',
  };

  const helpTextStyle = {
    color: '#546e7a',
    fontSize: '12px',
    fontStyle: 'italic',
    marginTop: '4px',
    display: 'block',
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-indigo-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Form Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 mb-4">
            <span className="text-3xl text-white">📋</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            {language === 'marathi' ? 'प्रमाणपत्र मागणी फॉर्म' : 'Certificate Request Form'}
          </h1>
          <p className="text-gray-600">
            {language === 'marathi' ? 'इनाम धामणी ग्रामपंचायत - आय/निवास/दारिद्र्यरेषा प्रमाणपत्र' : 'Inam Dhamani Gram Panchayat - Income/Residence/BPL Certificate'}
          </p>
          <div className="mt-4 w-24 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 mx-auto rounded-full"></div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Section 1: Applicant Information */}
          <div style={formSectionStyle}>
            <h2 style={sectionTitleStyle}>{language === 'marathi' ? 'अर्जदार माहिती' : 'Applicant Information'}</h2>
            
            <div className="space-y-6">
              {/* Applicant Name */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'अर्जदार नाव' : 'Applicant Name'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="applicantName"
                  value={formData.applicantName}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'श्री. / सुश्री. / कु. पूर्ण नाव' : 'Mr. / Ms. / Miss. Full Name'}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'अर्ज करणाऱ्या व्यक्तीचे संपूर्ण नाव प्रविष्ट करा' : 'Enter applicant\'s full name'}
                </span>
              </div>

              {/* Mobile Number */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'मोबाईल क्रमांक' : 'Mobile Number'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="tel"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? '९८७६५४३२१०' : '9876543210'}
                  pattern="[0-9]{10}"
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'अर्जदाराचा व्हॉट्सऑप मोबाईल क्रमांक प्रविष्ट करा' : 'Enter applicant\'s WhatsApp mobile number'}
                </span>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4 bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-700 font-semibold">
                {language === 'marathi' ? 'दाखल्यावरील तपशील' : 'Certificate Details'}
              </span>
            </div>
          </div>

          {/* Section 2: Certificate Details */}
          <div style={formSectionStyle}>
            <h2 style={sectionTitleStyle}>{language === 'marathi' ? 'दाखल्यावरील तपशील' : 'Certificate Details'}</h2>
            
            <div className="space-y-6">
              {/* Person Name in Marathi */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'दाखल्यावर येणारे व्यक्तीचे नाव (मराठी मध्ये)' : 'Name on Certificate (in Marathi)'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="personNameMarathi"
                  value={formData.personNameMarathi}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'मराठीत संपूर्ण नाव' : 'Full Name in Marathi'}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'दाखल्यावर येणारे व्यक्तीचे संपूर्ण नाव प्रविष्ट करा' : 'Enter the full name to appear on the certificate'}
                </span>
              </div>

              {/* Person Name in English */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'दाखल्यावर येणारे व्यक्तीचे नाव (इंग्रजी मध्ये)' : 'Name on Certificate (in English)'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="personNameEnglish"
                  value={formData.personNameEnglish}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder="Full Name in English"
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'दाखल्यावर येणारे व्यक्तीचे संपूर्ण नाव प्रविष्ट करा' : 'Enter the full name to appear on the certificate'}
                </span>
              </div>

              {/* Family Head Name in Marathi */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'कुटुंब प्रमुखाचे नाव (मराठी मध्ये)' : 'Head of Family Name (in Marathi)'}
                </label>
                <input
                  type="text"
                  name="familyHeadNameMarathi"
                  value={formData.familyHeadNameMarathi}
                  onChange={handleChange}
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'कुटुंब प्रमुखाचे नाव' : 'Head of Family Name'}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'कुटुंब प्रमुखाचे संपूर्ण नाव प्रविष्ट करा' : 'Enter full name of the head of the family'}
                </span>
              </div>

              {/* Poverty Line Number */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'दारिद्रारेषेतील नंबर' : 'BPL Number'}
                </label>
                <input
                  type="text"
                  name="povertyLineNumber"
                  value={formData.povertyLineNumber}
                  onChange={handleChange}
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'दारिद्र्य रेषा क्रमांक' : 'BPL Number'}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'दारिद्रारेषेतील नंबर प्रविष्ट करा' : 'Enter BPL Number'}
                </span>
              </div>

              {/* Relation with Family Head */}
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'कुटुंबप्रमुखाशी नाते (मराठी मध्ये)' : 'Relation with Head of Family (in Marathi)'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="relationWithFamilyHead"
                  value={formData.relationWithFamilyHead}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'जसे: पुत्र, पुत्री, पती, पत्नी, भाऊ, बहीण' : 'e.g. Son, Daughter, Husband, Wife, Brother, Sister'}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <span style={helpTextStyle}>
                  {language === 'marathi' ? 'कुटुंबप्रमुखाशी नाते प्रविष्ट करा' : 'Enter relation with head of family'}
                </span>
              </div>
            </div>
          </div>

          {/* Form Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 pt-6">
            <button
              type="submit"
              style={{
                background: 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)',
                color: 'white',
                padding: '12px 32px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '16px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(33, 150, 243, 0.3)',
              }}
              className="hover:shadow-lg transform hover:-translate-y-1"
              onMouseEnter={(e) => {
                e.target.style.boxShadow = '0 6px 20px rgba(33, 150, 243, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.boxShadow = '0 4px 15px rgba(33, 150, 243, 0.3)';
              }}
            >
              📄 {language === 'marathi' ? 'अर्ज सादर करा' : 'Submit Application'}
            </button>

            <button
              type="button"
              onClick={handleReset}
              style={{
                background: 'linear-gradient(135deg, #757575 0%, #616161 100%)',
                color: 'white',
                padding: '12px 32px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '16px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(117, 117, 117, 0.3)',
              }}
              className="hover:shadow-lg transform hover:-translate-y-1"
              onMouseEnter={(e) => {
                e.target.style.boxShadow = '0 6px 20px rgba(117, 117, 117, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.boxShadow = '0 4px 15px rgba(117, 117, 117, 0.3)';
              }}
            >
              🔄 {language === 'marathi' ? 'पुनर्स्थापित करा' : 'Reset'}
            </button>
          </div>

          {/* Form Footer */}
          <div className="mt-8 text-center text-sm text-gray-600">
            <p className="mb-2">
              <span style={{color: '#f44336', fontWeight: 'bold'}}>*</span> {language === 'marathi' ? 'हे चिन्ह असलेले फील्ड अनिवार्य आहेत' : 'Fields marked with this symbol are mandatory'}
            </p>
            <p>
              {language === 'marathi' 
                ? 'अर्ज सादर केल्यानंतर, तुम्हाला एक अर्ज संदर्भ क्रमांक प्राप्त होईल. कृपया तो संदर्भ क्रमांक नोंदवून ठेवा.'
                : 'After submitting the application, you will receive an application reference number. Please note down that reference number.'}
            </p>
          </div>
        </form>

        {/* Information Box */}
        <div className="mt-10 p-6 bg-gradient-to-r from-blue-100 to-indigo-100 border border-blue-200 rounded-lg">
          <h3 className="text-lg font-semibold text-blue-800 mb-3">{language === 'marathi' ? '📋 प्रमाणपत्राचे प्रकार:' : '📋 Types of Certificates:'}</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-white p-4 rounded-lg shadow-sm border border-blue-100">
              <h4 className="font-bold text-blue-700 mb-2">{language === 'marathi' ? 'आय प्रमाणपत्र' : 'Income Certificate'}</h4>
              <p className="text-sm text-gray-600">{language === 'marathi' ? 'वार्षिक उत्पन्नाचे दाखला' : 'Annual Income Certificate'}</p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-blue-100">
              <h4 className="font-bold text-blue-700 mb-2">{language === 'marathi' ? 'निवास प्रमाणपत्र' : 'Residence Certificate'}</h4>
              <p className="text-sm text-gray-600">{language === 'marathi' ? 'स्थायी निवासासाठी' : 'For Permanent Residence'}</p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-blue-100">
              <h4 className="font-bold text-blue-700 mb-2">{language === 'marathi' ? 'दारिद्र्यरेषा प्रमाणपत्र' : 'BPL Certificate'}</h4>
              <p className="text-sm text-gray-600">{language === 'marathi' ? 'गरिबी रेषेखालील कुटुंबांसाठी' : 'For Below Poverty Line Families'}</p>
            </div>
          </div>
          <div className="mt-4 pt-4 border-t border-blue-200">
            <p className="text-blue-700 text-sm">
              <span className="font-bold">{language === 'marathi' ? 'सूचना:' : 'Note:'}</span> {language === 'marathi' ? 'प्रमाणपत्रासाठी आवश्यक असलेली मूळ कागदपत्रे ग्रामसेवक कार्यालयात सादर करावी लागतील.' : 'Original documents required for the certificate must be submitted to the Gram Sevak office.'}
            </p>
          </div>
        </div>

        {/* Contact Information */}
        <div className="mt-6 text-center">
          <div className="inline-flex items-center space-x-4 bg-white p-4 rounded-lg shadow-sm border border-gray-200">
            <div className="text-left">
              <p className="text-sm font-semibold text-gray-700">{language === 'marathi' ? '📞 संपर्क क्रमांक:' : '📞 Contact Number:'}</p>
              <p className="text-gray-600">०२४१-XXXXXXX</p>
            </div>
            <div className="h-8 w-px bg-gray-300"></div>
            <div className="text-left">
              <p className="text-sm font-semibold text-gray-700">✉️ ईमेल:</p>
              <p className="text-gray-600">certificate@inamdhamani-grampanchayat.in</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProperStandard;